/**
 * PostNL logo — simplified inline SVG for sidebar icon use.
 * Resmi PostNL renkleri (resmi turuncu: #FF6900) — küçük ölçeklerde
 * tanınabilirlik için yuvarlatılmış-üçgen + taç silueti.
 *
 * Şub 09, 2026 — lucide Package icon yerine PostNL menü öğeleri için.
 */
import React from 'react';

const PostNLIcon = React.forwardRef(({ className = '', size, ...props }, ref) => {
  const dim = size || undefined;
  return (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={dim}
      height={dim}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Yuvarlatılmış üçgen çerçeve */}
      <path
        d="M50 8 C 20 8 6 30 6 50 C 6 70 20 92 50 92 C 80 92 94 70 94 50 C 94 30 80 8 50 8 Z"
        stroke="#FF6900"
        strokeWidth="7"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Taç (kraliyet sembolü) */}
      <path
        d="M38 42 L42 32 L46 38 L50 26 L54 38 L58 32 L62 42 L62 48 L38 48 Z"
        fill="#FF6900"
      />
      <rect x="36" y="48" width="28" height="4" rx="1" fill="#FF6900" />
      {/* postnl yazısının simgesel temsili — küçük üç çubuk */}
      <rect x="34" y="62" width="32" height="6" rx="2" fill="#FF6900" />
    </svg>
  );
});

PostNLIcon.displayName = 'PostNLIcon';

export default PostNLIcon;
